module.exports = __webpack_public_path__ + "static/img/1.a4a7341.png";


//////////////////
// WEBPACK FOOTER
// ./src/project/integralMallProject/images/1.png
// module id = Mg61
// module chunks = 5